import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose, withProps } from 'recompose';

import FilterInput from './FilterInput';

import * as actions from '../../actions';

import s from './styles.less';

const propTypes = {
  handleChange: PropTypes.func.isRequired,
  VRN: PropTypes.string,
  contractNumber: PropTypes.string,
};
const defaultProps = {
  VRN: '',
  contractNumber: '',
};

const PlanListFilters = ({ handleChange, VRN, contractNumber }) => (
  <div className={s.filters}>
    <div className={s.filter}>
      <FilterInput
        type="text"
        name="VRN"
        label="VRN"
        value={VRN}
        onChange={handleChange}
      />
    </div>
    <div className={s.filter}>
      <FilterInput
        type="text"
        name="contractNumber"
        label="Contract number"
        value={contractNumber}
        onChange={handleChange}
      />
    </div>
  </div>
);

PlanListFilters.propTypes = propTypes;
PlanListFilters.defaultProps = defaultProps;

const mapStateToProps = ({ admin: { plansFilter } }) => plansFilter;

export default compose(
  connect(
    mapStateToProps,
    {
      fetchPlans: actions.fetchPlans,
      updateFilter: actions.updateFilter,
    },
  ),
  withProps(({ updateFilter, fetchPlans }) => ({
    handleChange: ({ target: { name, value } }) => {
      updateFilter(name, value);
      fetchPlans();
    },
  })),
)(PlanListFilters);
